module.exports = __webpack_public_path__ + "static/store-icon-2-5acc5f21298a5df0ea785ccbadb79edb.svg";